/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import typography from 'storybookConfig/mixins/typography';

export const SubLinkContainer = styled.div<{ customMarginLeft?: string; borderLeft?: boolean }>`
  /* Section items line up with their header, as in Settings; only nested lists (categories) indent. */
  margin-left: ${(props) => props.customMarginLeft || '0'};
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ borderLeft, theme }) => (borderLeft ? `border-left: 1px solid ${theme.color.border};` : '')}
`;

/* Section headings: uppercase labels in ink. */
export const SectionHeading = styled.span`
  ${typography('Other/Section Label')};
  color: ${({ theme }) => theme.color.bodyTextPrimary};
`;
